export const actions = {
  set: 'SET::CURRENT_EMPLOYER',
  resetCurrentEmployer: 'RESET::CURRENT_EMPLOYER'
}
export const setCurrentEmployer = employer => ({ type: actions.set, employer })
export const getCurrentEmployer = state => state.currentEmployer
export default actions



// WEBPACK FOOTER //
// ./src/store/current-employer/actions.js